const time = (ts) => new Date(ts).toLocaleTimeString([], { hour12: false });
const COLOR = { decoded: "text-emerald-300", known: "text-amber-300", unknown: "text-rose-300", system: "text-slate-400" };

export const ExperimentLog = ({ entries }) => (
  <section data-testid="experiment-log" className="border border-cyan-400/20 bg-slate-950/60 p-4 font-mono text-xs">
    <p className="lab-label">Case log</p>
    <ul className="mt-3 grid gap-1.5">
      {entries.length === 0 && <li className="text-slate-600">[--:--:--] Awaiting first contact...</li>}
      {entries.map((e) => (
        <li key={e.at} data-testid="experiment-log-entry" data-kind={e.kind} className={`leading-snug ${COLOR[e.kind] || COLOR.system}`}>
          <span className="text-slate-600">[{time(e.at)}]</span> {e.text}
        </li>
      ))}
    </ul>
  </section>
);
